import { css } from 'styled-components';
import {
  getSpacing, getTypography, TypographyName, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const title: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H3)};
  ${getSpacing.marginBottom(theme, SpacingName.SMALLEST)};
`;

export const status: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginBottom(theme, SpacingName.SMALLER)};
`;

export const subtitle: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.SMALL)};
  ${getSpacing.marginBottom(theme, SpacingName.SMALLER)};
`;

export const price: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.paddingTop(theme, SpacingName.SMALL)};
  ${getTypography(theme, TypographyName.H4)};
`;

export const logo: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)};
  display: inline-block;
`;

export const highlightsWrapper = css`
  white-space: nowrap;
`;
